<div>
  <!-- <app-spinner [show]="showSpinner" [size]="150"> </app-spinner> -->
<div class="row" style="margin: 20px;">
  <div class="col-md-6">
     <h1> Pending Request</h1>
    </div>
</div>
<div class="grid-container">
  <div class="grid-item" *ngFor="let row of requests" > 
<div class="matCard mat-elevation-z4">
  <div class="row">
    <div class="col-sm-12 col-md-12 col-lg-12">
      <div class="row">
        <div class="col-sm-12 col-md-6 col-lg-6">
          Name : <span class="contentCls" style="cursor: pointer;" (click)="onHostInfo(row)"> {{row?.firstName}}  {{row?.lastName}}</span>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-6">
          Email : <span class="contentCls">  {{row?.email}} </span>
        </div>
        
      </div>
      <div class="row">
        <div class="col-sm-12 col-md-6 col-lg-6">
          Phone : <span class="contentCls"> {{row?.phone}}</span>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-6">
          Why Strong Seller ? : <span class="contentCls">  {{row?.whyStrongSeller}}</span>
        </div>
        </div>

        <div class="row">
        <div class="col-sm-12 col-md-6 col-lg-6">
          Submitted By : <span class="contentCls"> {{row?.submittedByNavigation?.firstName}} {{row.submittedByNavigation?.lastName}} </span>
        </div>
        <div class="col-sm-12 col-md-3 col-lg-3">
          Sister Website : 
        </div>
        <div class="col-sm-12 col-md-3 col-lg-3">
          <span class="contentCls"> 
            <mat-select  *ngIf="sisterWebsites" placeholder="Sister Website" (selectionChange)="SetSisterWebsite($event)">
              <mat-option *ngFor="let sisterWebsite of sisterWebsites" [value]="sisterWebsite.id">{{sisterWebsite.websiteName}}</mat-option>
            </mat-select>
          </span>
        </div>
      </div>
    </div>
  </div>
    <div class="row">
    <div class="col-sm-12 col-md-12 col-lg-12">
      <mat-icon  style="color:green;margin-left: 3px;cursor: pointer; font-size: 25px;" (click)="Approve(row.id)">check_circle_outline</mat-icon> 
      <mat-icon  style="color:red;margin-left: 3px;cursor: pointer;  font-size: 25px;" (click)="Reject(row.id)">highlight_off</mat-icon> 
      <mat-icon  style="color:green;margin-left: 3px;cursor: pointer; font-size: 25px;" (click)="onHostInfo(row)">info</mat-icon>
    </div>
  </div>
</div>
</div>
</div>
</div>

<!-- <div style="margin: 50px;">
<div class="row"  *ngIf="requests.length != 0">
    <div class="col-md-12">
    <mat-table [dataSource]="requests">
        <ng-container matColumnDef="Name">
            <mat-header-cell *matHeaderCellDef> Name </mat-header-cell>
            <mat-cell *matCellDef="let row"> {{row?.firstName}}  {{row?.lastName}}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="Email">
            <mat-header-cell *matHeaderCellDef> Email </mat-header-cell>
            <mat-cell *matCellDef="let row"> {{row?.email}} </mat-cell>
          </ng-container>
          <ng-container matColumnDef="Phone">
            <mat-header-cell *matHeaderCellDef> Phone </mat-header-cell>
            <mat-cell *matCellDef="let row"> {{row?.phone}} </mat-cell>
          </ng-container>
          <ng-container matColumnDef="WhyStrongSeller">
            <mat-header-cell *matHeaderCellDef> Why Strong Seller ? </mat-header-cell>
            <mat-cell *matCellDef="let row"> {{row?.whyStrongSeller}} </mat-cell>
          </ng-container>
          <ng-container matColumnDef="SubmittedBy">
            <mat-header-cell *matHeaderCellDef>Submitted By </mat-header-cell>
            <mat-cell *matCellDef="let row"> {{row?.submittedByNavigation?.firstName}} {{row.submittedByNavigation?.lastName}}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="SisterWebsite">
            <mat-header-cell *matHeaderCellDef>Sister Website </mat-header-cell>
            <mat-cell *matCellDef="let row"> 
            <mat-select  *ngIf="sisterWebsites" style="width: 80%;" placeholder="Sister Website" (selectionChange)="SetSisterWebsite($event)">
              <mat-option *ngFor="let sisterWebsite of sisterWebsites" [value]="sisterWebsite.id">{{sisterWebsite.websiteName}}</mat-option>
            </mat-select>
          </mat-cell>
          </ng-container>
          <ng-container matColumnDef="Actions">
            <mat-header-cell *matHeaderCellDef> Actions </mat-header-cell>
            <mat-cell *matCellDef="let row"> 
              <div class="col-12">              
                 <mat-icon  style="color:green;margin-left: 3px;cursor: pointer;" (click)="Approve(row.id)">check_circle_outline</mat-icon> 
                 <mat-icon  style="color:red;margin-left: 3px;cursor: pointer;" (click)="Reject(row.id)">highlight_off</mat-icon> 
              </div>  
               
            </mat-cell>
          </ng-container>
        <mat-header-row
        *matHeaderRowDef="['Name', 'Email' ,'Phone',  'WhyStrongSeller','SubmittedBy','SisterWebsite','Actions']; sticky: true">
      </mat-header-row>
      <mat-row
        *matRowDef="let row; columns: ['Name', 'Email' ,'Phone',  'WhyStrongSeller','SubmittedBy','SisterWebsite','Actions']"
        ></mat-row>
    </mat-table>
</div>
</div>
</div> -->